import { DATE_TIME_FORMAT, ERRORS_MESSAGE } from "@lhd/constants";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Checkbox, Form, FormInstance, Input } from "antd";
import { CommonDateFormPicker } from "@lhd/components/CommonDatePicker";
import moment from "moment";
import { FC, useEffect, useState } from "react";

type PropsType = {
  form: FormInstance;
  appPart: AppPartType;
  getFieldClassName?: (name: string) => string;
};

const DateTimeSetting: FC<PropsType> = ({
  form,
  appPart,
  getFieldClassName,
}) => {
  const [defaultDate, setDefaultDate] = useState(false);

  const calc_type = appPart?.calc_type;

  useEffect(() => {
    setDefaultDate(calc_type === "date_time");
  }, [calc_type]);

  const updatedValue = Form.useWatch("default_value", form);

  useEffect(() => {
    if (defaultDate) {
      form.setFieldsValue({
        calc_type: "date_time",
        default_value: null,
      });
    } else {
      form.setFieldsValue({ calc_type: null });
    }
  }, [defaultDate, form, updatedValue]);

  return (
    <>
      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_required_field"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>必須項目にする</Checkbox>
      </Form.Item>
      <Form.Item valuePropName="checked" name="is_prohibit_duplicate_values">
        <Checkbox>重複値を禁止する</Checkbox>
      </Form.Item>
      <Form.Item label="初期値" name="calc_type" valuePropName="checked">
        <Checkbox
          onChange={(e) => setDefaultDate(e.target.checked)}
          checked={defaultDate}
        >
          デフォルトはレコードの作成時間.
        </Checkbox>
      </Form.Item>
      <Form.Item
        getValueFromEvent={(date) =>
          date ? moment(date).format(DATE_TIME_FORMAT.DATE_TIME) : null
        }
        getValueProps={(i) => {
          if (i && i !== "Invalid date") {
            return { value: moment(i) };
          }
          return { value: null };
        }}
        noStyle
        name="default_value"
      >
        <CommonDateFormPicker
          showTime={{ format: "HH:mm" }}
          disabled={defaultDate}
          displayFormat={DATE_TIME_FORMAT.DATE_JP_TIME}
          placeholder="日付を選択"
          allowClear
        />
      </Form.Item>
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default DateTimeSetting;
